import { injector } from "@cervval.js/common/src/dependencies/injector";
import { DefaultDataSourceContext } from "@cervval.js/common/src/forms/dataSource";
import { PropertyConfig } from "@cervval.js/common/src/forms/propertyConfig";
import { CjsEditor } from "./editor";

export const EDITOR_FACTORY_SERVICE = "EditorFactory";

/** Access Editor Factory instance */
export function getEditorFactoryService(): EditorFactoryService {
    return injector.get<EditorFactoryService>(EDITOR_FACTORY_SERVICE);
}

/** Access Editor Factory instance if registered */
export function findEditorFactoryService(): EditorFactoryService | undefined {
    return injector.find<EditorFactoryService>(EDITOR_FACTORY_SERVICE);
}

export interface NewEditorOptions {
    /** Context to be passed to an editor that would use the DataSourceService */
    dataSourceContext?: DefaultDataSourceContext<unknown>;

    /** Used to know if we are building a creation editor thus we can set the first item as selected in every required selector */
    isCreationForm?: boolean;
}

/** 
 * Create an editor that suits the edition of the given property config's type.
 * 
 * @param options Any optional content that may be used to initialize the editor.
 * @param options.dataSourceContext Context to be passed to an editor that would use the DataSourceService
 * @param options.isCreationForm Used to know if we are building a creation editor thus we can set the first item as selected in every required selector
 */
export type EditorBuilder = (pc: PropertyConfig, options?: NewEditorOptions) => CjsEditor<unknown>;

/**
 * Editor factory that will provide you the most suitable editor.
 */
export interface EditorFactoryService {
    /** 
     * Create an editor that suits the edition of the given property config's type.
     * @see EditorBuilder
     */
    newEditor: EditorBuilder;

    /**
     * Register a builder for a specific typeUid, you can use this function to register a new type or to override the default builder for a specific type
     */
    registerEditorType(typeUid: string, params: {
        newEditor: EditorBuilder
    }): void;
}